import { motion } from "framer-motion";
import { coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const DLCourseDetail1 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <div className="images">
        <img src={props.img} alt="" />
      </div>
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>詳細課程內容:</span>
        </h2>
        <p>
          你對深度學習與人工智慧的核心技術感興趣嗎？本課程將帶你從基礎神經網路概念開始，循序漸進學習深度學習的完整流程，包含反向傳播、損失函數與優化方法，並逐步掌握
          CNN、ResNet、RNN、LSTM、GRU 以及
          BERT、GPT、Transformer、DALL-E、GAN、VAE、Diffusion
          等主流模型架構，理解其在影像辨識、自然語言處理與生成式 AI 中的應用。
        </p>
        <p>
          課程同時強調實作導向，使用 Python
          與主流深度學習框架（TensorFlow），帶你完成資料前處理、模型建構、訓練調參與效能評估等完整流程。
        </p>
        <p>
          課程設計 7 個實作
          Lab，包含車牌辨識系統、對抗樣本生成、風格轉移、序列資料處理等等，幫助你從零到一建立深度學習實戰能力。無論你是剛入門或想進一步強化
          AI
          技能，都能在這門課中打下堅實的深度學習基礎，現在就加入我們，開啟你的
          AI 深度學習之旅吧！
        </p>
      </motion.div>
    </div>
  );
};

export default DLCourseDetail1;
